import React, { useState } from 'react';
import { login } from '../services/authService'; // Servicio de autenticación
import { useNavigate } from 'react-router-dom';
import ParticlesComponent from './particles';
import './homePage.css';
import logoImg from '../images/logoOmnixOficial.png';
import CargaLayout from '../images/iconosMenu/CARGA_LAYOUT.png';
import Dashboard from '../images/iconosMenu/dashboard.png';
import ReportesEsp from '../images/iconosMenu/REPORTES_ESP.png';
import AdminUsuarios from '../images/iconosMenu/ADMIN_USUARIO.png';
import logoOmnixOficial from '../images/logoOmnixOficial.png';

function HomePage() {

  
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true); // Se muestra primero
  const [isClosing, setIsClosing] = useState(false); // Maneja la animación de cierre
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const closeModal = () => {
    setIsClosing(true); // Inicia animación de fadeOut
    setTimeout(() => {
      setShowModal(false); // Oculta el modal después de la animación
      setIsClosing(false); // Restablece el estado
    }, 300); // Tiempo igual al de la animación (0.3s)
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault(); // Evitar recarga del formulario
    console.log('Email:', email, 'Password:', password);
          // Llamar al servicio de login
          const userData = await login(email, password);
    
          // Guardar el usuario en localStorage
          localStorage.setItem('user', JSON.stringify(userData));
    
    closeModal(); // Cierra el modal con animación al hacer login
  };

  return (
    <div className='particulas'>
      <ParticlesComponent id="particles"/> 

      {/* Modal de Login (Aparece primero) */}
      {showModal && (
        <div className="modal-overlay">
          <div 
            className={`modal-content ${isClosing ? "modal-fade-out" : ""}`} 
            onClick={(e) => e.stopPropagation()}
          >
            <div className="card text-center">
              <div className="card-header bg-white border-0">
                <img src={logoOmnixOficial} alt="OMNIX Logo" className="img-fluid mb-2" />
              </div>
              <div className="card-body text-white">
                <form className='formLogin' onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-person"></i></span>
                      <input type="email" className="form-control" placeholder="e-mail / ID"
                        value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                  </div>
                  <br />
                  <div className="mb-3">
                    <div className="input-group">
                      <span className="input-group-text"><i className="bi bi-lock"></i></span>
                      <input type="password" className="form-control" placeholder="password"
                        value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </div>
                  </div>
                  <br />
                  {error && <p className="text-danger">{error}</p>}
                  <button type="submit" className="btn btn-light w-100">Login</button>
                </form>
                {/* Botón para cerrar sin iniciar sesión */}
                <button className="btn btn-danger mt-3" onClick={closeModal}>Cerrar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Contenido solo si el modal está cerrado */}
      {!showModal && (
        <div id="logoOficial">
          <img src={logoImg} alt=""/>
          <p className="introduccion">
            <b className='omnixTl'>OMNIX <br /></b>
            <i>
              Navegando en el Océano de los Datos <br />
              Con OMNIX, ¡sumérgete en la claridad y deja atrás la complejidad!
            </i>
          </p>
          <center>
            <div className="row row-cols-4">
              <div className="col opcion-inicio text-center" onClick={() => navigate('/usuarios')}>
                <img src={AdminUsuarios} alt="Administración de Usuarios" className="icon-inicio mb-3" /> <br />
                <button className="menuOpc">Administración de usuarios</button>
              </div>
              <div className="col opcion-inicio text-center" onClick={() => navigate('/dashboard')}>
                <img src={Dashboard} alt="Visualizar Dashboard" className="icon-inicio mb-3" /> <br />
                <button className="menuOpc">Dashboard Infográficos</button>
              </div>
              <div className="col opcion-inicio text-center" onClick={() => navigate('/cargar-layouts')}>
                <img src={CargaLayout} alt="Carga de Layouts" className="icon-inicio mb-3" /> <br />
                <button className="menuOpc">Carga de layouts</button>
              </div>
              <div className="col opcion-inicio text-center" onClick={() => navigate('/reportes')}>
                <img src={ReportesEsp} alt="Reportes Especiales" className="icon-inicio mb-3" /> <br />
                <button className="menuOpc">Reportes Especiales</button>
              </div>
            </div>
          </center>
        </div>
      )}
    </div>
  );
}

export default HomePage;
